import { css } from "@emotion/css";
import { mergeProps } from "react-aria";
import { Section as AriaSection, SectionProps } from "react-aria-components";

interface Props<T extends object> extends SectionProps<T> {}

export function _Section<T extends object>(props: Props<T>) {
  const { ...sectionProps } = props;

  const className = styles.section;

  return (
    <AriaSection
      {...mergeProps(sectionProps, {
        className: css(className),
      })}
    />
  );
}

const styles = {
  section: css({
    display: "flex",
    flexDirection: "column",
    padding: "var(--space-1)",
    gap: "var(--space-1)",

    ".react-aria-ListBoxItem": { paddingLeft: "var(--space-2-5)" },
  }),
};
